<template>
    <div class="stage-configurator">
        <div class="stage-indicator-controls">
            <div v-for="(element, index) in (configuration)" :key="index" class="stage-indicator">
                <div :class="getLeftSeparatorClasses(index)" />
                <DsIconButton
                    v-if="isStageConfigured(element.stageStep)"
                    name="check"
                    class="stage-step-button stage-button design-ready"
                    @click="showConfigurationTab(element.stageStep)"
                />
                <DsButton
                    v-else
                    variant="outline"
                    :class="getStageIndicatorButtonClasses(element.stageStep)"
                    @click="showConfigurationTab(element.stageStep)"
                >
                    {{ element.navigationIconTitle }}
                </DsButton>
                <div :class="getRightSeparatorClasses(index)" />
            </div>
        </div>
        <div class="stage-indicator-controls">
            <div v-for="(element, index) in (configuration)" :key="index" class="stage-indicator-subtitle">
                <label class="stage-label"> {{ element.navigationSubtitle }} </label>
            </div>
        </div>
        <div class="stage-config-content">
            <div v-for="(element, index) in (configuration)" :key="index" :class="`stage-content-${index}`">
                <div v-if="isStageActive(element.stageStep)">
                    <slot :name="element.slotName" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        configuration: {
            type: Array,
            required: true,
        },
        currentStageStep: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            displayFirstStage: true,
        };
    },
    methods: {
        showConfigurationTab(stageId) {
            if (this.currentStageStep !== stageId) {
                if (stageId > this.currentStageStep) {
                    this.$emit('next-tab', this.currentStageStep);
                } else {
                    this.$emit('previous-tab', stageId);
                }
            }
        },

        isStageActive(stageId) {
            return this.currentStageStep === stageId;
        },

        isStageConfigured(stageId) {
            return this.currentStageStep > stageId;
        },

        getStageIndicatorButtonClasses(stageId) {
            let classes = 'stage-step-button stage-button';

            if (this.isStageActive(stageId)) classes = `${classes} stage-step-button-active`;

            return classes;
        },

        getLeftSeparatorClasses(stageId) {
            let classes = 'left-stage-separator';

            if (stageId === 0) classes = `${classes}-none`;
            if (this.isStageActive(stageId) || this.isStageConfigured(stageId)) classes = `${classes} separator-active`;

            return classes;
        },

        getRightSeparatorClasses(stageId) {
            let classes = 'right-stage-separator';

            if (stageId === this.configuration.length - 1) classes = `${classes}-none`;
            if (this.isStageConfigured(stageId)) classes = `${classes} separator-active`;

            return classes;
        },
    },
};
</script>

<style lang="scss" scoped>
.stage-configurator {
    width: 100%;
    padding-top: $spacing-300;
;
}
.stage-indicator-controls,
.stage-config-content {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.stage-config-content {
    padding-top: $spacing-500;
}

.stage-indicator {
    display: grid;
    grid-template-areas: 'leftstageseparator stagebutton rightstageseparator';
    width: fit-content;
    align-items: center;
    justify-items: center;
    margin: 0 auto;
    font-size: $font-size-sm;
    font-weight: 500;
    line-height: $line-height-sm;
}
.stage-step-button {
    background-color: $color-paper;
    color: $color-ink;
    border: px-to-rem(2) solid $color-gray-200;
    border-radius: 50%;
    width: px-to-rem(32);
    height: px-to-rem(32);
    font-size: px-to-rem(15);
    font-weight: 500;
    line-height: $line-height-sm;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
}
.stage-step-button-active {
    border: $nav-border-accent-thickness solid $color-blue-700;
}
.design-ready {
    color: $color-paper;
    background-color: $color-blue-700;
    border: $nav-border-accent-thickness solid $color-blue-700;
}
.stage-button {
    grid-area: stagebutton;
}
.stage-indicator-subtitle {
    width: px-to-rem(82);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
.stage-label {
    width: fit-content;
}
.left-stage-separator {
    grid-area: leftstageseparator;
    width: px-to-rem(24);
    height: px-to-rem(0);
    border-top: 1px solid $color-gray-200;
    border-bottom: 1px solid $color-gray-200;
}
.right-stage-separator {
    grid-area: rightstageseparator;
    width: px-to-rem(24);
    height: px-to-rem(0);
    border-top: 1px solid $color-gray-200;
    border-bottom: 1px solid $color-gray-200;
}
.right-stage-separator-none {
    grid-area: rightstageseparator;
    width: px-to-rem(24);
    height: px-to-rem(0);
}
.left-stage-separator-none {
    grid-area: leftstageseparator;
    width: px-to-rem(24);
    height: px-to-rem(0);
}
.separator-active {
    border-color: $color-blue-700;
}
</style>
